module.exports = __webpack_public_path__ + "yadokari-moshi-sam.png?e07f6f791683f7942401825600f1579f";


//////////////////
// WEBPACK FOOTER
// ./static/img/yadokari-moshi-sam.png
// module id = 207
// module chunks = 0